import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

const BG = '#0f0707';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: BG,
        borderTop: `1px solid ${alpha('#fff', 0.07)}`,
        py: 1.25,
        px: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mt: 'auto',
      }}
    >
      <Typography sx={{ color: alpha('#fff', 0.22), fontSize: '0.7rem' }}>
        © {new Date().getFullYear()} Janschitz GmbH
      </Typography>
      <Typography sx={{ color: alpha('#fff', 0.12), fontSize: '0.7rem' }}>
        GTMS V4
      </Typography>
    </Box>
  );
}

export default Footer;
